import { peek, selector } from 'lib/selectors'
import { ExperienceType, StateInterface } from 'types/state'

const experience = (state: StateInterface) => state.experience
export const workExperiencesListSelector = selector(experience, (e: ExperienceType) =>
  e.get('workExperiencesList')
)
export const workExperienceSelector = selector(experience, peek('workExperience'))
